
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingut/nachhaltigkeit",
      function () {
        return require("private-next-pages/weingut/nachhaltigkeit.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingut/nachhaltigkeit"])
      });
    }
  